export const OPEN_EMAIL_POPUP = 'OPEN_EMAIL_POPUP';
export const CLEAR_OPEN_EMAIL_POPUP_STATES = 'CLEAR_OPEN_EMAIL_POPUP_STATES';
export const JOB_BOARD_SMS_DATA = 'JOB_BOARD_SMS_DATA';
export const CLEAR_JOB_BOARD_SMS_DATA = 'CLEAR_JOB_BOARD_SMS_DATA';
export const INCREASE_JOB_BOARD_SMS_DATA = 'INCREASE_JOB_BOARD_SMS_DATA';
export const CLEAR_INCREASE_JOB_BOARD_SMS_DATA =
  'CLEAR_INCREASE_JOB_BOARD_SMS_DATA';

//  Create ro job
export const CREATE_RO_JOB_REQUEST = 'CREATE_RO_JOB_REQUEST';
export const CREATE_RO_JOB_SUCCESS = 'CREATE_RO_JOB_SUCCESS';
export const CREATE_RO_JOB_FAIL = 'CREATE_RO_JOB_FAIL';

//  Generate RO
export const GENERATE_RO_REQUEST = 'GENERATE_RO_REQUEST';
export const GENERATE_RO_SUCCESS = 'GENERATE_RO_SUCCESS';
export const GENERATE_RO_FAIL = 'GENERATE_RO_FAIL';

//  Ro Listing
export const GET_RO_LISTING_REQUEST = 'GET_RO_LISTING_REQUEST';
export const GET_RO_LISTING_SUCCESS = 'GET_RO_LISTING_SUCCESS';
export const GET_RO_LISTING_FAIL = 'GET_RO_LISTING_FAIL';

//  getting ro's for jobboard
export const GET_RO_JOB_CARDS_REQUEST = 'GET_RO_JOB_CARDS_REQUEST';
export const GET_RO_JOB_CARDS_SUCCESS = 'GET_RO_JOB_CARDS_SUCCESS';
export const GET_RO_JOB_CARDS_FAIL = 'GET_RO_JOB_CARDS_FAIL';

//  update ro card
export const UPDATE_RO_JOB_CARD_REQUEST = 'UPDATE_RO_JOB_CARD_REQUEST';
export const UPDATE_RO_JOB_CARD_SUCCESS = 'UPDATE_RO_JOB_CARD_SUCCESS';
export const UPDATE_RO_JOB_CARD_FAIL = 'UPDATE_RO_JOB_CARD_FAIL';

// updaing card state
export const UPDATE_CARD_STATUS = 'UPDATE_CARD_STATUS';

// Get RO
export const GET_RO_REQUEST = 'GET_RO_REQUEST';
export const GET_RO_SUCCESS = 'GET_RO_SUCCESS';
export const UPDATE_INVOICE_IN_RO = 'UPDATE_INVOICE_IN_RO';
export const GET_RO_SUCCESS_LOADER_OFF = 'GET_RO_SUCCESS_LOADER_OFF';

export const GET_CUSTOMER_STATS = 'GET_CUSTOMER_STATS';
export const GET_RO_FAIL = 'GET_RO_FAIL';
export const UPDATE_RO_SELECTED_CUSTOMER = 'UPDATE_RO_SELECTED_CUSTOMER';
export const ADD_NEW_VEHICLE_TO_RO = 'ADD_NEW_VEHICLE_TO_RO';
export const UPDATE_RO_SELECTED_VEHICLE = 'UPDATE_RO_SELECTED_VEHICLE';
export const UPDATE_RO_SELECTED_CUSTOMER_VEHICLES =
  'UPDATE_RO_SELECTED_CUSTOMER_VEHICLES';
export const DELETE_INSPECTIONS_SUCCESS = 'DELETE_INSPECTIONS_SUCCESS';

export const UPDATE_RO_PDF_URLS = 'UPDATE_RO_PDF_URLS';

// get inspection pdf data

export const GET_INSPECTION_PDF_DATA_REQUEST =
  'GET_INSPECTION_PDF_DATA_REQUEST';
export const GET_INSPECTION_PDF_DATA_SUCCESS =
  'GET_INSPECTION_PDF_DATA_SUCCESS';
export const GET_INSPECTION_PDF_DATA_FAIL = 'GET_INSPECTION_PDF_DATA_FAIL';

// Get RO Authorization History

export const GET_AUTHORIZATION_HISTORY_REQUEST =
  'GET_AUTHORIZATION_HISTORY_REQUEST';
export const GET_AUTHORIZATION_HISTORY_SUCCESS =
  'GET_AUTHORIZATION_HISTORY_SUCCESS';
export const GET_AUTHORIZATION_HISTORY_FAIL = 'GET_AUTHORIZATION_HISTORY_FAIL';

// get purchases
export const GET_PURCHASES_REQUEST = 'GET_PURCHASES_REQUEST';
export const GET_PURCHASES_SUCCESS = 'GET_PURCHASES_SUCCESS';
export const GET_PURCHASES_FAIL = 'GET_PURCHASES_FAIL';

// Update RO
export const UPDATE_RO_REQUEST = 'UPDATE_RO_REQUEST';
export const UPDATE_RO_SUCCESS = 'UPDATE_RO_SUCCESS';
export const UPDATE_RO_FAIL = 'UPDATE_RO_FAIL';
export const CLEAR_UPDATE_RO_STATE = 'CLEAR_UPDATE_RO_STATE';

// delete ro
export const DELETE_RO_REQUEST = 'DELETE_RO_REQUEST';
export const DELETE_RO_SUCCESS = 'DELETE_RO_SUCCESS';
export const DELETE_RO_FAIL = 'DELETE_RO_FAIL';
export const CLEAR_DELETED_RO_STATE = 'CLEAR_DELETED_RO_STATE';

// geeting genral info for side nbar
export const GET_GENERAL_INFO_REQUEST = 'GET_GENERAL_INFO_REQUEST';
export const GET_GENERAL_INFO_SUCCESS = 'GET_GENERAL_INFO_SUCCESS';
export const GET_GENERAL_INFO_FAIL = 'GET_GENERAL_INFO_FAIL';

// getting comments list
export const GET_ALL_COMMENTS_REQUEST = 'GET_ALL_COMMENTS_REQUEST';
export const GET_ALL_COMMENTS_SUCCESS = 'GET_ALL_COMMENTS_SUCCESS';
export const GET_ALL_COMMENTS_FAIL = 'GET_ALL_COMMENTS_FAIL';

// creating  comments
export const CREATE_COMMENT_REQUEST = 'CREATE_COMMENT_REQUEST';
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS';
export const CREATE_COMMENT_FAIL = 'CREATE_COMMENT_FAIL';

// update comment
export const UPDATE_COMMENT_REQUEST = 'UPDATE_COMMENT_REQUEST';
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_FAIL = 'UPDATE_COMMENT_FAIL';

// reply to  comment
export const SEND_REPLY_REQUEST = 'SEND_REPLY_REQUEST';
export const SEND_REPLY_SUCCESS = 'SEND_REPLY_SUCCESS';
export const SEND_REPLY_FAIL = 'SEND_REPLY_FAIL';

// update  reply to  comment
export const UPDATE_REPLY_REQUEST = 'UPDATE_REPLY_REQUEST';
export const UPDATE_REPLY_SUCCESS = 'UPDATE_REPLY_SUCCESS';
export const UPDATE_REPLY_FAIL = 'UPDATE_REPLY_FAIL';

// deleting comment
export const DELETE_COMMENT_REQUEST = 'DELETE_COMMENT_REQUEST';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_FAIL = 'DELETE_COMMENT_FAIL';

// deleting reply
export const DELETE_REPLY_REQUEST = 'DELETE_REPLY_REQUEST';
export const DELETE_REPLY_SUCCESS = 'DELETE_REPLY_SUCCESS';
export const DELETE_REPLY_FAIL = 'DELETE_REPLY_FAIL';

// getting messages list
export const GET_ALL_MESSAGES_REQUEST = 'GET_ALL_MESSAGES_REQUEST';
export const GET_ALL_MESSAGES_SUCCESS = 'GET_ALL_MESSAGES_SUCCESS';
export const GET_ALL_MESSAGES_FAIL = 'GET_ALL_MESSAGES_FAIL';

// sending message
export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAIL = 'SEND_MESSAGE_FAIL';

// get all  emails
export const GET_ALL_EMAIL_REQUEST = 'GET_ALL_EMAIL_REQUEST';
export const GET_ALL_EMAIL_SUCCESS = 'GET_ALL_EMAIL_SUCCESS';
export const GET_ALL_EMAIL_FAIL = 'GET_ALL_EMAIL_FAIL';

// send  emails
export const SEND_EMAIL_REQUEST = 'SEND_EMAIL_REQUEST';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL';

// get all  media attachments
export const GET_MEDIA_ATTACHMENTS_REQUEST = 'GET_MEDIA_ATTACHMENTS_REQUEST';
export const GET_MEDIA_ATTACHMENTS_SUCCESS = 'GET_MEDIA_ATTACHMENTS_SUCCESS';
export const GET_MEDIA_ATTACHMENTS_FAIL = 'GET_MEDIA_ATTACHMENTS_FAIL';

// share ro pdfs
export const SHARE_RO_PDF_REQUEST = 'SHARE_RO_PDF_REQUEST';
export const SHARE_RO_PDF_SUCCESS = 'SHARE_RO_PDF_SUCCESS';
export const SHARE_RO_PDF_FAIL = 'SHARE_RO_PDF_FAIL';
export const CLEAR_SHARE_RO_PDF_STATES = 'CLEAR_SHARE_RO_PDF_STATES';

// clearing communications statess
export const CLEAR_COMMUNICATIONS_STATES = 'CLEAR_COMMUNICATIONS_STATES';

// Inspection List Update
export const INSPECTION_LIST_UPDATE = 'INSPECTION_LIST_UPDATE';
// cleearing created job state
export const CLEAR_CREATED_JOB_RO_STATES = 'CLEAR_CREATED_JOB_RO_STATES';

// Tech Recommendation List Update
export const TECH_RECOMMENDATION_LIST_UPDATE =
  'TECH_RECOMMENDATION_LIST_UPDATE';

// Inspection Delete from List on Update
export const INSPECTION_DELETE_FROM_LIST = 'INSPECTION_DELETE_FROM_LIST';

// Tech Recommendation Delete from List on Update
export const TECH_RECOMMENDATION_DELETE_FROM_LIST =
  'TECH_RECOMMENDATION_DELETE_FROM_LIST';

// Clear RO States
export const CLEAR_RO_STATES = 'CLEAR_RO_STATES';

// SIDEBAR
export const UPDATE_SIDEBAR_REQUEST = 'UPDATE_SIDEBAR_REQUEST';
export const UPDATE_SIDEBAR_SUCCESS = 'UPDATE_SIDEBAR_SUCCESS';
export const UPDATE_SIDEBAR_FAIL = 'UPDATE_SIDEBAR_FAIL';

export const UPDATE_VEHICLE_IMAGES = 'UPDATE_VEHICLE_IMAGES';

// nexPart Data
export const NEX_PART_DATA = 'NEX_PART_DATA';

// update ro stage
export const UPDATE_RO_STAGE_REQUEST = 'UPDATE_RO_STAGE_REQUEST';
export const UPDATE_RO_STAGE_SUCCESS = 'UPDATE_RO_STAGE_SUCCESS';
export const UPDATE_RO_STAGE_FAIL = 'UPDATE_RO_STAGE_FAIL';
export const CLEAR_UPDATE_RO_STAGE_STATE = 'CLEAR_UPDATE_RO_STAGE_STATE';
export const UPDATE_RO_STAGE_FROM_PAYMENT = 'UPDATE_RO_STAGE_FROM_PAYMENT';

// update ro tags

export const UPDATE_RO_TAG = 'UPDATE_RO_TAG';

export const LOCK_RO = 'LOCK_RO';

export const CLEAR__AC__REC = 'CLEAR__AC__REC';
